import React, { useMemo } from 'react'

import { ToggleButtonProps } from './ToggleButton.types'

const ToggleButton: React.FC<ToggleButtonProps> = ({
    forceAtLeastOne = false,
    allowMultiple = false,
    onChange,
    value,
    options,
}) => {
    const renderOptions = useMemo(() => {
        return options.map((o, i) => {
            const isSelected = value.indexOf(o.val) !== -1
            return (
                <div
                    key={i}
                    onClick={() => {
                        if (o.isDisabled) {
                            return
                        }

                        if (!allowMultiple) {
                            onChange([o.val])
                        } else {
                            let newVal = value.slice()
                            if (isSelected) {
                                newVal = newVal.filter((v) => v !== o.val)
                                if (forceAtLeastOne && newVal.length === 0) {
                                    return
                                }
                            } else {
                                newVal.push(o.val)
                            }
                            onChange(newVal)
                        }
                    }}
                    className={`r-togglebutton-option ${o.isDisabled ? 'r-state-disabled' : ''} ${
                        isSelected ? 'r-state-selected' : ''
                    }`}
                >
                    {o.label}
                </div>
            )
        })
    }, [options, value])

    return (
        <div data-testid='ToggleButton' className='r-togglebutton-container'>
            {renderOptions}
        </div>
    )
}

export default ToggleButton
